import React from 'react';
import { Link } from 'react-router-dom';  // Import Link for navigation
import './NavBar.css';

export default function NavBar() {
  return (
    <div className="nav__container">
      <div className="nav__left">
        <Link to="/">Hotlapping Events</Link>
        <Link to="/race-results">Race Results</Link>
        <Link to="/championships">Championships</Link>
      </div>
      <div className="nav__right">
        <Link to="/circuit-records">Circuit Records</Link>
        <Link to="/vehicle-records">Vehicle Records</Link>
        <Link to="/driver-data">Driver Data</Link>
      </div>
    </div>
  );
}
